import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const AnimatedLink = ({ text, href }) => {
  const [isHovered, setIsHovered] = useState(false);
  const letters = text.split("");

  return (
    <Link
      to={href}
      style={{ display: "inline-block", textDecoration: "none" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {letters.map((letter, i) => (
        <motion.span
          key={i}
          animate={{
            color: isHovered ? "#7A7A7A" : "#12F7D6",
          }}
          transition={{
            duration: 0.3,
            delay: isHovered ? i * 0.05 : i * 0.05, // задержка при наведении и при уходе
          }}
          style={{ display: "inline-block" }}
        >
          {letter}
        </motion.span>
      ))}
    </Link>
  );
};

export default AnimatedLink;